App.D.on('click', '.js-pharmacy-show', function(e) {
    e.preventDefault();

    let textMore = $(this).data('text-more');
    let textLess = $(this).data('text-less');

    if($(this).parents('.js-pharmacy-info').hasClass('_opened')) {
        $(this).parents('.js-pharmacy-info').removeClass('_opened');
        $(this).text(textMore);
    } else {
        $(this).parents('.js-pharmacy-info').addClass('_opened');
        $(this).text(textLess);
    }
});
